import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    class: "service-box w-full flex"
};
const _hoisted_2 = {
    class: "service-box__container w-full flex flex-col p-[3.2rem] rounded-[1.6rem] bg-white shadow-[0px_8px_24px_0px_rgba(0,0,0,0.10)]"
};
const _hoisted_3 = {
    class: "service-box__head w-full flex"
};
const _hoisted_4 = [
    "innerHTML"
];
const _hoisted_5 = {
    class: "service-box__content w-full flex mt-[1.6rem]"
};
const _hoisted_6 = [
    "innerHTML"
];
const _hoisted_7 = {
    class: "service-box__btn w-full flex mt-[2rem]"
};
const _hoisted_8 = [
    "href"
];
export default {
    __name: 'ServiceBox',
    props: {
        service: {
            type: Object,
            default: ()=>{}
        }
    },
    setup (__props) {
        return (_ctx, _cache)=>{
            return _openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("h3", {
                            class: "head display-sm",
                            innerHTML: __props.service.title.rendered
                        }, null, 8, _hoisted_4)
                    ]),
                    _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("p", {
                            class: "desc body-md",
                            innerHTML: __props.service.excerpt.rendered
                        }, null, 8, _hoisted_6)
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("a", {
                            href: __props.service.link,
                            class: "btn btn--link btn--icon",
                            "data-icon": "b"
                        }, "Zobacz szczegóły", 8, _hoisted_8)
                    ])
                ])
            ]);
        };
    }
};
